module.exports = __webpack_public_path__ + "img/tips.83def2b2.png";